import React from 'react'
import axios from 'axios';
import { useState , useEffect} from 'react';
import parse from 'html-react-parser';

export default function Eula() {

    const [editorHtml, setEditorHtml] = useState('');
    useEffect(() => {
        const fetchTermsAndConditions = async () => {
          try {
            const response = await axios.post('https://beeitech.com/backend/terms_conditions',{"id":6});
            // console.log(response);vite
            let html = parse(response.data.result)
            setEditorHtml(html);
            // const x = parse('<li>Item 1</li><li>Item 2</li>');
            // console.log(x);
          } catch (error) {
            console.error('Error:', error);
          }
        };
    
        fetchTermsAndConditions();
      }, []);



  return (
    <div className='page-container'>
    <div className='page'>
      {editorHtml}
    </div>
    </div>
  )
}
